/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
import React from 'react';
import {
    arrayOf, number, shape, string, bool, array,
} from 'prop-types';
// import mbpLogger from 'mbp-logger';

import Button from '@material-ui/core/Button';
import Media from 'react-media';
import OrderListItem from './OrderListItem';
import SearchInput from '../../common/Search';
import { isEmpty } from '../../utils/object';
import configENV from '../../config';
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';
import DesktopOrderList from '../DesktopOrdersList/DesktopOrderList';

const { MAX_ORDER_LIST } = configENV;

class OrderList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            allOrders: [],
            ROSSOrderList: [],
            totalOrderCounter: 0,
            maxItem: MAX_ORDER_LIST, // Limited to 20 orders for the first view
        };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const {
            ROSSOrders,
            orders,
        } = this.props;
        let orderGroups = [];
        let ROSSOrderGroups = [];
        let totalOrderCounter = 0;
        if (!isEmpty(orders)) {
            orderGroups = [...this.regroupOrders(orders)]; // eslint-disable-line react/destructuring-assignment
            totalOrderCounter = orderGroups.length;
        }
        if (!isEmpty(ROSSOrders)) {
            ROSSOrderGroups = [...this.regroupOrders(ROSSOrders)]; // eslint-disable-line react/destructuring-assignment
            totalOrderCounter = ROSSOrderGroups.length;
        }
        this.setState({
            orders: orderGroups,
            allOrders: orderGroups,
            ROSSOrderList: ROSSOrderGroups,
            totalOrderCounter,
        });
    };

    // randRange = max => Math.floor(Math.random() * Math.floor(max));

    // orderStatus = () => {
    //     // I->In transit
    //     // D/U->Delivered
    //     // C->Cancelled
    //     // W and all other status->Order Received
    //     const status = ['C', 'W', 'I', 'D'];
    //     const step = this.randRange(4);
    //     if (step >= 0 && step < 4) {
    //         return status[step];
    //     }
    //     return 'W';
    // };

    scrollTop = () => {
        if (typeof window !== 'undefined') {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        }
    };

    regroupOrders = (orders) => {
        const newOrders = [];
        orders.map((order) => {
            const index = newOrders.findIndex((item) => item.orderNumber === order.orderNumber);
            const { items } = order;
            items.map((item) => {
                // for GraphQL and ROSS, bring modifyOrder and intOrderNumber to item level
                // `intOrderNumber` will be used to identify whether it's the same or different logical order.
                item.modifyOrder = order.modifyOrder;
                item.intOrderNumber = order.intOrderNumber;
                // for GraphQL only, override item.status with item.paymentStatus
                if (typeof item.status === 'undefined' && typeof item.paymentStatus !== 'undefined') {
                    item.status = item.paymentStatus;
                }
                // store parent order attributes into item object
                // deliveryLink or carrier may be used for different logical order
                item.orderStatusAttributes = {
                    orderNumber: order.orderNumber,
                    intOrderNumber: order.intOrderNumber,
                    modifyOrder: order.modifyOrder,
                    orderPlacedDate: order.orderPlacedDate,
                    customerFirstName: order.customerFirstName,
                    customerLastName: order.customerLastName,
                    parentOrderNumber: order.parentOrderNumber,
                    status: order.status,
                    trackingNumber: order.trackingNumber,
                    type: order.type,
                    statusDescription: order.statusDescription,
                    carrier: order.carrier,
                    deliveryLink: order.deliveryLink,
                    history: order.history,
                };
                // Group item with the same item.orderNumber
                if (index > -1) {
                    const itemIndex = newOrders[index]?.items?.findIndex((a) => a.intOrderNumber === item.intOrderNumber);
                    // make sure the item wasn't already moved into the newOrders[index].items array;
                    // it's happening when we resize the window which causes the re-rendering process
                    if (itemIndex === -1) {
                        newOrders[index].items.push(item);
                    }
                }
            });
            if (index === -1) { // if duplicate item.orderNumber not found
                newOrders.push({ ...order });
            }
        });
        return newOrders;
    };

    handleSearchOrdersChange = (data) => {
        const { search } = data;
        const { orders: regroupOrders } = this.props;
        const orders = regroupOrders.filter((order) => {
            const { items } = order;
            const itemJoin = items.map((item) => [
                item.productSku,
                item.recpFirstName,
                item.recpLastName,
                item.trackingNumber,
            ].join(' '));
            return [order.orderNumber, itemJoin]
                .join(' ')
                .match(new RegExp(search, 'ig'));
        });
        this.setState({ orders });
    };

    handleLoadMoreOrders = () => {
        let { maxItem } = this.state;
        const { totalOrderCounter } = this.state;
        maxItem += MAX_ORDER_LIST;
        if (maxItem >= totalOrderCounter) {
            maxItem = totalOrderCounter;
        }
        this.setState({ maxItem });
    };

    render() {
        const { allOrders, maxItem, totalOrderCounter } = this.state;
        const {
            breakpoint, userProfile, ROSSOrders, isROSSUIEnabled,
        } = this.props;
        let { orders, ROSSOrderList } = this.state;
        orders = orders?.slice(0, maxItem);
        ROSSOrderList = ROSSOrderList?.slice(0, maxItem) || [];
        const breakpointExpr =  `(max-width: ${(breakpoint || CUSTOM_BREAKPOINTS.tabLandscape)}px)`;

        return (
            <>
                <SearchInput
                    label="Search Order"
                    className="display-none"
                    onChange={this.handleSearchOrdersChange}
                />

                <Media query={breakpointExpr}>
                    {(matches) => (
                        matches ? (
                            <>
                                {(isROSSUIEnabled && !isEmpty(ROSSOrderList)) ? ROSSOrderList?.map((ROSSOrder, i) => (
                                    <OrderListItem
                                        key={ROSSOrder?.intOrderNumber}
                                        ROSSOrder={ROSSOrder}
                                        className={i === ROSSOrderList?.length - 1 ? 'last' : ''}
                                        userProfile={userProfile}
                                        isROSSUIEnabled={isROSSUIEnabled}
                                    />
                                )) : orders?.map((order, i) => (
                                    <OrderListItem
                                        key={order?.intOrderNumber}
                                        order={order}
                                        className={i === orders?.length - 1 ? 'last' : ''}
                                        userProfile={userProfile}
                                        isROSSUIEnabled={isROSSUIEnabled}
                                    />
                                ))}
                            </>
                        ) : (
                            <>
                                {(isROSSUIEnabled && !isEmpty(ROSSOrderList)) ? ROSSOrderList?.map((ROSSOrder) => (
                                    <DesktopOrderList key={ROSSOrder.intOrderNumber} userProfile={userProfile} ROSSOrder={ROSSOrder} isROSSUIEnabled={isROSSUIEnabled} />
                                )) : orders?.map((order) => <DesktopOrderList key={order.intOrderNumber} order={order} userProfile={userProfile} isROSSUIEnabled={isROSSUIEnabled} />)}
                            </>
                        )
                    )}
                </Media>
                {((allOrders?.length && totalOrderCounter > orders?.length) || (ROSSOrders?.length && totalOrderCounter > ROSSOrderList?.length)) ? (
                    <div className="align-center margin-top-2x margin-bottom-2x">
                        <Button
                            onClick={() => this.handleLoadMoreOrders()}
                            variant="contained"
                            className="do-not-remove-btn secondary float-none"
                        >
                            Load More Orders
                        </Button>
                    </div>
                ) : (
                    ''
                )}
            </>
        );
    }
}
OrderList.defaultProps = {
    breakpoint: CUSTOM_BREAKPOINTS.tabLandscape,
};
OrderList.propTypes = {
    orders: arrayOf(
        shape({
            orderNumber: string,
            intOrderNumber: string,
            orderPlaceddate: string,
            customerFirstName: string,
            customerLastName: string,
            modifyOrder: string,
            parentOrderNumber: string,
            uuid: string,
            items: arrayOf(
                shape({
                    brandId: string,
                    productSku: string,
                    productName: string,
                    recpFirstName: string,
                    recpLastName: string,
                    shipDate: string,
                    paymentStatus: string,
                    estimatedDeliveryDate: string,
                    trackingNumber: string,
                    itemType: string,
                    sfItemType: string,
                    addonType: string,
                    parentLineNumber: string,
                    childLineNumber: string,
                    flexDate: string,
                    flexMessage: string,
                    flexGuaranteedFlag: string,
                    prdImgCtg: string,
                    prdImgTmn: string,
                    arrivalStartDate: string,
                    arrivalEndDate: string,
                    carrier: string,
                    seoUrl: string,
                    subscriptionType: string,
                    interval: string,
                    duration: string,
                }),
            ),
        }),
    ).isRequired,
    ROSSOrders: arrayOf(
        shape({
            brandId: string,
            modifiedDateTime: string,
            orderNumber: string,
            modifyOrder: string,
            uuid: string,
            status: string,
            orders: arrayOf(
                shape({
                    carrier: string,
                    history: array,
                    brandId: string,
                    type: string,
                    deliveryDate: string,
                    modifiedDateTime: string,
                    status: string,
                    statusDescription: string,
                    trackingNumber: string,
                    warningMessage: string,
                    items: arrayOf(
                        shape({
                            duration: string,
                            interval: string,
                            itemType: string,
                            prdImgCtg: string,
                            prdImgTmn: string,
                            productName: string,
                            productSku: string,
                            seoUrl: string,
                            subscriptionType: string,
                        }),
                    ),
                }),
            ),
        }),
    ).isRequired,
    breakpoint: number,
    userProfile: shape({
        isAuthenticated: bool.isRequired,
    }).isRequired,
    isROSSUIEnabled: bool.isRequired,
};

export default OrderList;
